var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglelogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google logo",
    clipPath: "url(#clip0_88_6944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 10.2216C20.5 9.40171 20.4319 8.80343 20.2846 8.18299H10.7041V11.8835H16.3276C16.2143 12.8031 15.6021 14.188 14.2415 15.1186L14.2224 15.2425L17.2516 17.5357L17.4615 17.5561C19.3889 15.8167 20.5 13.2573 20.5 10.2216Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7041 19.9714C13.4591 19.9714 15.772 19.085 17.4614 17.5561L14.2414 15.1186C13.3798 15.7058 12.2233 16.1158 10.7041 16.1158C8.00566 16.1158 5.71542 14.3764 4.89902 11.9721L4.77935 11.9821L1.62957 14.3641L1.58838 14.476C3.26637 17.7333 6.71309 19.9714 10.7041 19.9714Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.89905 11.9721C4.68363 11.3517 4.55897 10.6869 4.55897 10C4.55897 9.31304 4.68363 8.6483 4.88772 8.02786L4.88201 7.89573L1.69276 5.47539L1.58841 5.52389C0.89683 6.87559 0.5 8.3935 0.5 10C0.5 11.6065 0.89683 13.1243 1.58841 14.476L4.89905 11.9721Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.7041 3.88417C12.6201 3.88417 13.9126 4.69295 14.6496 5.36884L17.5294 2.62114C15.7608 1.01464 13.4591 0.0285716 10.7041 0.0285716C6.71309 0.0285716 3.26637 2.26659 1.58838 5.52389L4.88769 8.02786C5.71542 5.62365 8.00566 3.88417 10.7041 3.88417Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_6944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelogo);
export default __webpack_public_path__ + "static/media/Googlelogo.8a896133a95fb0b1a8f1705a9fba4dab.svg";
export { ForwardRef as ReactComponent };